<!-- Copyright 2024 Midas Healthcare Solutions - All Rights Reserved -->
<mat-form-field class="example-chip-list" appearance="fill" *transloco="let t">
  <mat-label [innerHTML]="t(label)"></mat-label>
  <mat-chip-grid #chipGrid>
    <mat-chip-row *ngFor="let type of items" (removed)="remove(type)">
      {{ type.name }}
      <button matChipRemove>
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip-row>
  </mat-chip-grid>
  <input
    #searchInput
    [formControl]="searchCtrl"
    [matChipInputFor]="chipGrid"
    [matAutocomplete]="auto"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
  />
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option *ngFor="let type of filteredItems | async" [value]="type">
      {{ type.name }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>